
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { setupGlobalErrorHandling } from './utils/error-logger'
import { logger } from './services/logger'

// Initialize global error handling
setupGlobalErrorHandling();

// Log application start
logger.info('Application starting', {
  metadata: {
    version: import.meta.env.VITE_APP_VERSION || '1.0.0',
    environment: import.meta.env.MODE,
    buildTime: import.meta.env.VITE_BUILD_TIME || new Date().toISOString()
  }
});

createRoot(document.getElementById("root")!).render(
  <App />
);

// Fallback error component to show when there's an unrecoverable error
function FallbackErrorComponent() {
  return (
    <div className="min-h-screen bg-[#212121] flex flex-col items-center justify-center p-4 text-white">
      <h1 className="text-2xl font-bold mb-4">Etwas ist schiefgelaufen</h1>
      <p className="mb-6">Wir entschuldigen uns für die Unannehmlichkeiten. Bitte lade die Seite neu oder kontaktiere uns, wenn das Problem weiterhin besteht.</p>
      <div className="flex flex-col sm:flex-row gap-4">
        <button 
          onClick={() => window.location.reload()}
          className="px-4 py-2 bg-[#2C6E49] rounded-lg hover:bg-[#4C956C] transition-colors"
        >
          Seite neu laden
        </button>
        <a 
          href="mailto:support@chrona.it" 
          className="px-4 py-2 bg-[#212121] border border-white rounded-lg hover:bg-gray-800 transition-colors text-center"
        >
          Support kontaktieren
        </a>
      </div>
    </div>
  );
}
